import React from 'react';
const HTMLDiv = (props) => {
    const { html, ...rest } = props;
    return React.createElement("div", Object.assign({}, rest, { dangerouslySetInnerHTML: { __html: props.html ?? '' } }));
};
export default HTMLDiv;
